import { FC } from 'react';
import { SectionProps } from '#/containers/asideNavigation/Sections';
import { Can } from '#/components/roles/Can';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { useI18n } from '#hooks/useI18n';
import { Private } from '#/containers/router/routes/Private';

interface AgentOwnerLeadsProps extends SectionProps {
}

export const AgentOwnerLeads: FC<AgentOwnerLeadsProps> = ({ onClickItem, depth, isMobile }) => {
  const { t } = useI18n();
  return <Can hasRoles={['agent', 'buildingManager', 'admin']} hideFromZazumeUser>
    <NavigationLink
      to={Private.AGENT_OWNER_LEADS.route}
      isMobile={isMobile}
      onClick={onClickItem}
      depth={depth}
      title={t('general.leads')}
      icon="people"
    />
  </Can>;
};
